/**
 * @fileoverview Contact Fields settings page
 *
 * URL: /dashboard/firm-contacts/fields
 *
 * Field-Presets-style manager for per-category custom firm-contact field
 * definitions (Role, Rate, Experience, BSB, …). Shares the grey settings
 * canvas with the Field Presets page for visual consistency.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { useActiveOrg } from "@/utils/org-context";
import { FirmContactFieldsManager } from "@/components/firm-contacts/FirmContactFieldsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/firm-contacts/fields",
)({
  component: ContactFieldsPage,
  beforeLoad: () => ({
    title: "Contact Fields",
    headerTitle: "Firm Contacts",
  }),
});

function ContactFieldsPage() {
  const { activeOrg, isLoading } = useActiveOrg();

  if (isLoading) {
    return (
      <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!activeOrg) {
    throw redirect({ to: "/dashboard" });
  }

  const canEdit = activeOrg.role === "owner" || activeOrg.role === "admin";

  return (
    <div className="flex h-full w-full flex-col bg-muted">
      <div className="mx-auto flex w-full max-w-screen-xl flex-1 flex-col p-6">
        <FirmContactFieldsManager orgId={activeOrg._id} canEdit={canEdit} />
      </div>
    </div>
  );
}
